import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'
import { OtpInputForm } from 'src/components/auth/otp-input-form/OtpInputForm'
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'
import React, { useCallback, useMemo } from 'react'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'

export const ClientEnterCodePage = () => {
  const location = useLocation()
  const params = useParams()
  const navigate = useNavigate()

  const phone = useMemo(() => location?.state?.phone || '****', [location])

  const handleBack = useCallback(() => {
    navigate(-1)
  }, [])

  if (!params?.partnerName || !location?.state?.phone) {
    return <Navigate to={CLIENT_ROUTES.NOT_FOUND_URL} />
  }

  return (
    <ClientPublicWrapper>
      <Button
        color="light"
        leftIcon={<ChevronLeftMinor width={19} css={tw`fill-primary-500`} />}
        size="medium"
        onClick={handleBack}
        data-testid="header-nav-back-btn"
      >
        Back
      </Button>
      <Typography variant="h2" css={tw`mb-2 mt-6`}>
        Enter the verification code we just sent.
      </Typography>
      <Typography css={tw`mb-6 text-shades-400`}>
        {`A verification code has been sent to the phone number ending in ${phone.slice(-4)}.`}
      </Typography>
      <OtpInputForm partnerName={params.partnerName} phone={phone} platform="client" />
    </ClientPublicWrapper>
  )
}
